// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* tabelas_matricula.css */
.tabela-matriculas th {
    font-size: 0.85rem;
    text-transform: uppercase;
    vertical-align: middle;
}

.tabela-matriculas td {
    font-size: 0.85rem;
    vertical-align: middle;
}

/* Cores condicionais (Evita repetição de código no React) */
.text-positivo {
    color: green;
    font-weight: bold;
}

.text-negativo {
    color: red;
    font-weight: bold;
}

/* Faixas de Evasão/Renovação */
.bg-darkred {
    background-color: darkred !important;
    color: white !important;
    font-weight: 500;
}

.bg-red {
    background-color: red !important;
    color: white !important;
    font-weight: 500;
}

.bg-orange {
    background-color: orange !important;
    color: white !important;
    font-weight: 500;
}

.bg-green {
    background-color: green !important;
    color: white !important;
    font-weight: 500;
}

.bg-black {
    background-color: black !important;
    color: white !important;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Modulos/tabelas_matricula.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,4DAA4D;AAC5D;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":["/* tabelas_matricula.css */\n.tabela-matriculas th {\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    vertical-align: middle;\n}\n\n.tabela-matriculas td {\n    font-size: 0.85rem;\n    vertical-align: middle;\n}\n\n/* Cores condicionais (Evita repetição de código no React) */\n.text-positivo {\n    color: green;\n    font-weight: bold;\n}\n\n.text-negativo {\n    color: red;\n    font-weight: bold;\n}\n\n/* Faixas de Evasão/Renovação */\n.bg-darkred {\n    background-color: darkred !important;\n    color: white !important;\n    font-weight: 500;\n}\n\n.bg-red {\n    background-color: red !important;\n    color: white !important;\n    font-weight: 500;\n}\n\n.bg-orange {\n    background-color: orange !important;\n    color: white !important;\n    font-weight: 500;\n}\n\n.bg-green {\n    background-color: green !important;\n    color: white !important;\n    font-weight: 500;\n}\n\n.bg-black {\n    background-color: black !important;\n    color: white !important;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
